import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

interface RoleItem {
    rolename: string;
    value: string;

}

type Error = {
    input: string;
    message: string;
}

interface MessageList {
    time: string;
    title: string;
    message:string;
}

export class userStore {
    cognitoUser = null;
    username: string = "";
    useremail: string = "";
    selectedEmail: string = "";
    changePasswordUser: string = "";
    forgotPasswordUser: string = "";
    forgotPassUserError: string = "";
    password: string = "";
    profileUrl: string = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png';
    passwordVisibility: boolean = false;
    loginError: Error = {input: "",message: ""};
    step: number = 1;
    varificationCode: number | null = null;
    newPassword: string = "";
    newPasswordVisibility: boolean = false;
    confirmPassword: string = "";
    newUserPasswordVisibility: boolean = false;
    newUserOldPasswordVisibility: boolean = false;
    confirmPasswordVisibility: boolean = false;
    newUserConfirmPasswordVisibility: boolean = false;
    forgotPassSubmitError: Error = {input: "",message: ""};
    emailVerificationError: string = "";
    emailVerificationCodeError: Error = {input: "",message: ""};
    ChangePassSubmitError: Error = {input: "",message: ""};
    successMessage: string = "";
    changePasswordSuccessMessage: string = "";
    newUserPassword: string = "";
    newUserOldPassword: string = "";
    newUserConfirmPassword: string = "";
    verificationCode: string = "";
    multiLogin: boolean = false;
    pageRefresh: number = 1;
    codeExcution: boolean | null = null;
    roleArr: RoleItem[] = [];
    chooseRole: string = "";
    restrictUserModal: boolean = false;
    roleSelectModal: boolean = false;
    sameUserLoginModal: boolean = false;

    session: string = "";

    signIn: boolean = false;
    sendCode: boolean = false;
    submitCode: boolean = false;
    changePassword: boolean = false;
    bellIconClick: boolean = false;
    messagelist:MessageList[]=[];



    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }
    setProfileUrl = (url:string) => {
        this.profileUrl = url
    }
    get getProfileUrl (){
        return this.profileUrl
    }

    setCognitoUser = (user: any) => {
        this.cognitoUser = user;
    }
    get getCognitoUser() {
        return this.cognitoUser;
    }

    setSignIn = (val: boolean) => {
        this.signIn = val;
    }
    get getSignIn() {
        return this.signIn;
    }

    setSendCode = (val: boolean) => {
        this.sendCode = val;
    }
    get getSendCode() {
        return this.sendCode;
    }

    setSubmitCode = (val: boolean) => {
        this.submitCode = val;
    }
    get getSubmitCode() {
        return this.submitCode;
    }

    setChangePassword = (val: boolean) => {
        this.changePassword = val;
    }
    get getChangePassword() {
        return this.changePassword;
    }

    setUsername = (user: string) => {
        this.username = user;
    }
    get getUsername() {
        return this.username;
    }

    setUseremail = (email: string) => {
        this.useremail = email;
    }
    get getUseremail() {
        return this.useremail;
    }

    setSelectedEmail = (selectedEmail: string) => {
        this.selectedEmail = selectedEmail;
    }
    get getSelectedEmail() {
        return this.selectedEmail;
    }

    setChangePassUser = (u: string) => {
        this.changePasswordUser = u;
    }
    get getChangePasswordUser() {
        return this.changePasswordUser;
    }

    setForgotPasswordUser = (user: string) => {
        this.forgotPasswordUser = user;
    }
    get getForgotPasswordUser() {
        return this.forgotPasswordUser;
    }

    setPassword = (password: string) => {
        this.password = password;
    }
    get getPassword() {
        return this.password;
    }

    setLoginError = (inputType: string,errorMsg: string) => {
        let error = {
            input: inputType,
            message: errorMsg
        }
        this.loginError = error;
    }
    get getLoginError() {
        return this.loginError;
    }
    resetLoginError = () => {
        let error = {
            input: "",
            message: ""
        }
        this.loginError = error;
    }

    setForgotPassUserError = (errorMsg: string) => {
        this.forgotPassUserError = errorMsg;
    }
    get getForgotPassUserError() {
        return this.forgotPassUserError;
    }

    setForgotPassSubmitError = (inputType: string,errorMsg: string) => {
        let error = {
            input: inputType,
            message: errorMsg
        }
        this.forgotPassSubmitError = error;
    }
    get getForgotPassSubmitError() {
        return this.forgotPassSubmitError;
    }
    resetForgotPassSubmitError = () => {
        let error = {
            input: "",
            message: ""
        }
        this.forgotPassSubmitError = error;
    }

    setEmailVarificationCodeError = (inputType: string,errorMsg: string) => {
        let error = {
            input: inputType,
            message: errorMsg
        }
        this.emailVerificationCodeError = error;
    }
    get getEmailVarificationCodeError() {
        return this.emailVerificationCodeError;
    }
    resetEmailVarificationCodeError = () => {
        let error = {
            input: "",
            message: ""
        }
        this.emailVerificationCodeError = error;
    }

    setEmailVerificationError = (errorMsg: string) => {
        this.emailVerificationError = errorMsg;
    }
    get getEmailVerificationError() {
        return this.emailVerificationError;
    }

    setChangePassSubmitError = (inputType: string,errorMsg: string) => {
        let error = {
            input: inputType,
            message: errorMsg
        }
        this.ChangePassSubmitError = error;
    }
    get getChangePassSubmitError() {
        return this.ChangePassSubmitError;
    }
    resetChangePassSubmitError = () => {
        let error = {
            input: "",
            message: ""
        }
        this.ChangePassSubmitError = error;
    }

    setStep = (step: number) => {
        this.step = step;
    }
    get getStep() {
        return this.step;
    }

    setVarificationCode = (code: number) => {
        this.varificationCode = code;
    }
    get getVarificationCode() {
        return this.varificationCode;
    }

    setNewPassword = (password: string) => {
        this.newPassword = password;
    }
    get getNewPassword() {
        return this.newPassword;
    }

    setConfirmPassword = (password: string) => {
        this.confirmPassword = password;
    }
    get getConfirmPassword() {
        return this.confirmPassword;
    }

    setPasswordVisiblity = (isPasswordVisible: boolean) => {
        this.passwordVisibility = isPasswordVisible;
    }
    get getPassVisibility() {
        return this.passwordVisibility;
    }

    setNewPasswordVisibility = (isNewPasswordVisible: boolean) => {
        this.newPasswordVisibility = isNewPasswordVisible
    }
    get getNewPasswordVisibility() {
        return this.newPasswordVisibility;
    }
    
    setNewUserPasswordVisibility = (isNewPasswordVisible: boolean) => {
        this.newUserPasswordVisibility = isNewPasswordVisible
    }
    get getNewUserPasswordVisibility() {
        return this.newUserPasswordVisibility;
    }

    setNewUserOldPasswordVisibility = (isNewPasswordVisible: boolean) => {
        this.newUserOldPasswordVisibility = isNewPasswordVisible
    }
    get getNewUserOldPasswordVisibility() {
        return this.newUserOldPasswordVisibility;
    }

    setNewUserConfirmPasswordVisibility = (isConfirmPasswordVisible: boolean) => {
        this.newUserConfirmPasswordVisibility = isConfirmPasswordVisible;
    }
    get getNewUserConfirmPasswordVisibility() {
        return this.newUserConfirmPasswordVisibility;
    }

    setConfirmPasswordVisibility = (isConfirmPasswordVisible: boolean) => {
        this.confirmPasswordVisibility = isConfirmPasswordVisible;
    }
    get getConfirmPasswordVisibility() {
        return this.confirmPasswordVisibility;
    }
    setSuccessMsg = (successMessage: string) => {
        this.successMessage = successMessage;
    }
    get getSuccessMsg() {
        return this.successMessage;
    }

    setChangePasswordSuccessMsg = (successMessage: string) => {
        this.changePasswordSuccessMessage = successMessage;
    }
    get getChangePasswordSuccessMsg() {
        return this.changePasswordSuccessMessage;
    }
    
    setNewUserPassword = (newpassword: string) => {
        this.newUserPassword = newpassword;
    }
    get getNewUserPassword() {
        return this.newUserPassword;
    }

    setNewUserOldPassword = (newpassword: string) => {
        this.newUserOldPassword = newpassword;
    }
    get getNewUserOldPassword() {
        return this.newUserOldPassword;
    }

    setNewUserConfirmPassword = (newpassword: string) => {
        this.newUserConfirmPassword = newpassword;
    }
    get getNewUserConfirmPassword() {
        return this.newUserConfirmPassword;
    }

    setVerificationCode = (vCode: string) => {
        this.verificationCode = vCode;
    }
    get getVerificationCode() {
        return this.verificationCode;
    }

    setSession = (session: string) => {
        this.session = session;
    }
    get getSession() {
        return this.session;
    }

    setMultiLogin = (isPopUpShow: boolean) => {
        this.multiLogin = isPopUpShow;
    }
    get getMultiLogin() {
        return this.multiLogin;
    }

    setpageRefresh = () => {
        this.pageRefresh++;
    }
    get getPageRefresh() {
        return this.pageRefresh;
    }

    setCodeExcution = (isCodeContinue: boolean) => {
        this.codeExcution = isCodeContinue;
    }
    get getCodeExcutionStatus() {
        return this.codeExcution;
    }

    handleUserRestModal = (isShow: boolean) => {
        this.restrictUserModal = isShow;
    }
    get getUserRestModal() {
        return this.restrictUserModal;
        }
    
    handleRoleSelectModal = (isVisible: boolean) => {
        this.roleSelectModal = isVisible;
    }
    get getRoleSelectModal() {
        return this.roleSelectModal;
    }

    handleSameloginUserModal = (isVisible: boolean) => {
        this.sameUserLoginModal = isVisible;
    }
    get getSameloginUserModal() {
        return this.sameUserLoginModal;
    }

    handleRoleArr = (role: string, value: string) => {
        let newItem = {
            rolename: role,
            value: value
        }
        this.roleArr.push(newItem);
    }
    get getRoleArr() {
        return this.roleArr;
    }

    handleRoleChoose = (uRole: string) => {
        this.chooseRole = uRole;
    }
    get getURole() {
        return this.chooseRole;
    }

    handleBellIconClick = () => {
        this.bellIconClick = !this.bellIconClick;
    }
    get getBellIconClick() {
        return this.bellIconClick;
    }
 


} 